









































import Vue from 'vue';

export default Vue.extend({
  name: 'SiloTransfer',
  props: {
    sourceSiloNumber: {
      type: Number,
      required: true,
    },
    targetSiloNumber: {
      type: Number,
      required: true,
    },
    transferClearanceBitSet: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data: () => {
    return {
      success: undefined as boolean | undefined,
      loading: false,
      targetPercentage: 50 as number,
    };
  },
  methods: {
    async sendTransferSign(): Promise<void> {
      this.success = undefined;
      this.loading = true;

      try {
        await this.$siloService.sendTransferSiloRelationSign(
          this.sourceSiloNumber,
          this.targetSiloNumber,
          this.targetPercentage
        );
        this.success = true;
      } catch {
        this.success = false;
      } finally {
        setTimeout(() => (this.success = undefined), 5000);
        this.loading = false;
      }
    },
  },
});
